export const aboutData = {
  brandName: '羊宫妃那词条百科',
  slogan: '探索网络文化的深度与温度',
  introduction: `「羊宫妃那词条百科」是一个专注于网络流行文化研究与传播的中文百科平台。我们致力于以严谨的态度、通俗的语言，为读者提供高质量的网络流行语解析、二次元文化分析和声优相关内容。

我们的团队由资深二次元文化研究者、语言学爱好者和内容创作者组成。每一位成员都怀着对网络文化的热爱和敬畏，希望通过我们的努力，让更多人理解和欣赏这个充满活力的文化领域。`,
  mission: '我们的使命是搭建一座桥梁——连接核心粉丝群体与更广泛的文化受众，让网络流行文化被正确理解和尊重。',
  values: [
    {
      title: '严谨求真',
      description: '每一个词条都经过多方考证，确保信息来源可靠、内容准确无误。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '深入浅出',
      description: '用通俗易懂的语言解释复杂的文化现象，让每个人都能轻松理解。',
      icon: 'ri-lightbulb-line',
    },
    {
      title: '开放包容',
      description: '尊重多元文化视角，为不同观点提供平等的表达空间。',
      icon: 'ri-heart-line',
    },
    {
      title: '持续更新',
      description: '紧跟网络文化发展步伐，及时更新和完善词条内容。',
      icon: 'ri-refresh-line',
    },
  ],
  reputation: {
    stats: [
      { label: '累计词条', value: '200+' },
      { label: '月活跃读者', value: '50万+' },
      { label: '合作媒体', value: '30+' },
      { label: '内容创作者', value: '15+' },
    ],
    testimonials: [
      {
        content: '这个网站对网络流行语的解析非常到位，既有深度又通俗易懂。作为文化研究者，我很欣赏他们的专业态度。',
        author: '张教授',
        role: '某高校文化研究院',
      },
      {
        content: '作为一个二次元新人，这个百科帮我快速了解了圈内的各种用语和文化背景，强烈推荐！',
        author: '小陈',
        role: 'B站UP主',
      },
      {
        content: '「羊宫妃那我来草你了」这篇文章简直是神作，把这句话背后的文化脉络讲得太清楚了。',
        author: '阿强',
        role: '资深动漫爱好者',
      },
    ],
  },
  contact: {
    email: 'contact@tjcongling.cn',
    weibo: '@羊宫妃那词条百科',
    bilibili: '羊宫妃那词条百科',
    address: '中国上海市浦东新区张江高科技园区',
  },
};